/*
 * @Author: Qian.qianchen
 * @Date: 2019-04-08
 * @LastEditTime: 2020-10-15 16:18:29
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\manuscriptPreview\iwoManuscriptPreview.js
 * @Description: 融合编辑稿件查看页
 */

'use strict';
angular.module('iWoManuscriptPreviewModule', ['trsPreviewHeightModule', 'trsPreviewContentModule']).controller('iWoManuscriptPreviewCtrl', [
    '$scope',
    'initeditctrBtnsService',
    '$stateParams',
    '$q',
    'trsHttpService',
    'modalDialog',
    'localStorageService',
    '$state',
    '$window',
    'trsPrintService',
    'editcenterRightsService',
    function(
        $scope,
        initeditctrBtnsService,
        $stateParams,
        $q,
        trsHttpService,
        modalDialog,
        localStorageService,
        $state,
        $window,
        trsPrintService,
        editcenterRightsService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                listOpen: 1,
                iwoplatform: $stateParams.iwoplatform,
                iwometadataid: $stateParams.iwometadataid,
                btnRights: {},
                previewBigFace: {
                    status: false,
                },
            };
            $scope.data = {
                userData: [],
                broadcastStr: '',
                reporterStr: '',
                editorArr: [],
                printResult: [],
            };
            initBtnRights();
        }

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            var methodnameArray = ['iwo.personal', 'iwo.received'];
            if ($stateParams.iwoplatform == 2 || $stateParams.iwoplatform == 3) {
                return;
            }
            initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                });
            });
            // 获取查看痕迹按钮权限
            editcenterRightsService.initIwoListBtn('iwo.trace').then(function(data) {
                $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
            });
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description] 获取广电广电文稿数据
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusiontv',
                methodname: 'getVirtualWenGaoDoc',
                SourceDocId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                data.EXATTRIBUTE = data.EXATTRIBUTE instanceof Array ? data.EXATTRIBUTE : [];
                $scope.data.manuscriptDetail = data;
                $scope.data.reporterStr = data.FGD_AUTHINFO.map(function(item) {
                    return item.USERNAME;
                }).join('、');
                $scope.data.compileStr = data.FGD_EDITINFO.map(function(item) {
                    return item.USERNAME;
                }).join('、');
                $scope.data.broadcastStr = data.BROADCASTING.map(function(item) {
                    return item.USERNAME;
                }).join('、');
                $scope.data.bigFaceData = angular.copy($scope.data.manuscriptDetail);
                $scope.data.bigFaceData.METADATAID = $scope.status.iwometadataid;
                document.title = data.TITLE;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getAllUsers description] 获取全部系统用户
         * @return {[type]} [description]
         */
        function getAllUsers() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'queryUsersByName',
                IsSearchAll: true,
                Name: '',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.userData = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getObjFromArr description] 根据属性查询数组中的对象
         * @param  {[type]} arr      [description] 数组
         * @param  {[type]} property [description] 属性名
         * @param  {[type]} value    [description] 属性只
         * @return {[type]}          [description]
         */
        function getObjFromArr(arr, property, value) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][property] == value) {
                    return arr[i];
                }
            }
            return -1;
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            // 88
            var pageTurningData;
            pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
            var metadataid = $stateParams.iwometadataid;
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (
                    pageTurningData[i].METADATAID === metadataid ||
                    pageTurningData[i].DOCID === metadataid ||
                    pageTurningData[i].MLFID === metadataid
                ) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if (toPageData.DOCTYPEID == '9' || toPageData.DOCTYPE == '9') {
                broadcastingAndTVGostate(
                    toPageData.DOCTYPEID,
                    toPageData.METADATAID || toPageData.DOCID,
                    toPageData.CHNLDOCID,
                    'iwomanuscriptpreview'
                );
            } else if (toPageData.DOCTYPEID == '11' || toPageData.DOCTYPE == '11') {
                broadcastingAndTVGostate(
                    toPageData.DOCTYPEID,
                    toPageData.METADATAID || toPageData.DOCID,
                    toPageData.CHNLDOCID,
                    'iwoseriessheetpreview'
                );
            } else {
                if ($stateParams.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($stateParams.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.DOCID, toPageData.CHNLDOCID);
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID);
                }
            }
        };

        /**
         * [broadcastingAndTVGostate 广电广电文稿预览页跳转]
         * @param  {[type]} doctype       [description]
         * @param  {[type]} iwometadataid [description]
         * @param  {[type]} iwochnldocid  [description]
         * @param  {[type]} mlftype       [description]
         * @param  {[type]} collectid     [description]
         * @param  {[type]} channel       [description]
         * @return {[type]}               [description]
         */
        function broadcastingAndTVGostate(doctype, iwometadataid, iwochnldocid, channel) {
            var url = channel,
                routerParams = {
                    iwotype: doctype,
                    iwomodalname: $stateParams.iwomodalname,
                    wzplatform: 0,
                    wztypeid: doctype,
                    appplatform: 0,
                    newspapertype: 2,
                    iwometadataid: iwometadataid,
                    iwochnldocid: iwochnldocid,
                    iwoplatform: $stateParams.iwoplatform,
                    // mlftype: mlftype, //是否来自资源中心
                    // iwodoccollectrelid: collectid,
                };
            routerParams.appdoctype = doctype;
            $state.go(url, routerParams, {
                reload: true
            }); // new
        }

        /**
         * [fusionGostate description]
         *
         * @param   {[type]}  doctype        [doctype description]
         * @param   {[type]}  iwometadataid  [iwometadataid description]
         * @param   {[type]}  iwochnldocid   [iwochnldocid description]
         * @param   {[type]}  mlftype        [mlftype description]
         * @param   {[type]}  collectid      [collectid description]
         *
         * @return  {[type]}                 [return description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var url = 'fusionpreview',
                routerParams = {
                    iwotype: doctype,
                    iwomodalname: $stateParams.iwomodalname ? $stateParams.iwomodalname : 'iwo.personal',
                    wzplatform: 0,
                    wztypeid: doctype,
                    appplatform: 0,
                    newspapertype: 2,
                    iwometadataid: iwometadataid,
                    iwochnldocid: iwochnldocid,
                    mlftype: mlftype, // 是否来自资源中心
                    iwodoccollectrelid: collectid,
                    iwoplatform: $stateParams.iwoplatform,
                };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) {
                // iwo
                getBindingMediaIds(iwometadataid).then(function(bingdingData) {
                    angular.forEach(bingdingData, function(value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        }
                    });
                    $state.go(url, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go(url, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [creationAxis description] 添加到个人素材
         * @return {[type]} [description]
         */
        $scope.creationAxis = function() {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'addPersonalMaterialOfTxt',
                PersonalMaterialId: 0,
                metadataid: $stateParams.iwometadataid,
                MediaType: '-1',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $window.document.getSelection().collapse($window.document, 1);
            });
        };

        /**
         * [edit description] 编辑
         * @return {[type]} [description]
         */
        $scope.edit = function() {
            var routerParams = {
                iwoplatform: 0,
                iwometadataid: $stateParams.iwometadataid,
                iwochnldocid: $stateParams.iwochnldocid,
                isfromplannedorder: false,
            };
            $state.go('iwobroadcasttvmanuscript', routerParams);
        };

        /**
         * [printBtn 打印]
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            $scope.status.isESSearch = false;
            // if (checkDraftType($scope.status.draftType.subject)) {
            //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
            //     return;
            // }
            // angular.forEach($scope.data.selectedArray, function(value, key) {
            requestPrintData();
            // });
        };

        /**
         * [requestPrintData 打印请求详情]
         * @param  {[type]} item    [description]
         * @param  {[type]} version [description]
         * @return {[type]}         [description]
         */
        function requestPrintData(item) {
            var params;
            params = {
                serviceid: 'mlf_fusiontv',
                methodname: 'getVirtualWenGaoDoc',
                SourceDocId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.PLATFORM = 'iwo';
                // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                // if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                trsPrintService.trsTvPrintDocument($scope.data.printResult);
                $scope.data.printResult = [];
                // }
            });
        }

        /**
         * [bigFace description] 查看痕迹
         * @return {[type]} [description]
         */
        $scope.bigFace = function() {
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        };
    },
]);
